<template>
    <div style="font-family: QHKT;">
        <div style="height: 100vh;">
            <video autoplay muted class="background-video" id="backVideo" ref="videoElement" loop>
                <source :src=videoSrc type="video/mp4" />
            </video>
            <!-- <video-background :video-src="require('@/assets/index/back.mp4')"> -->
            <div class="logo">
                <transition name="logo" appear>
                    <div>
                        <div style="width: 40vw;display: flex;flex-direction: row;justify-content: center;">
                            <img src="../../assets/index/logo_white.png" style="width: 32vw;height: 20vh;">
                        </div>
                        <p
                            style="font-size:44px;width: 40vw;display: flex;flex-direction: row;justify-content: center;margin-top: 20px;font-family: QHKT; color: #ffffff;">
                            先进燃烧技术领跑者</p>
                    </div>
                </transition>
            </div>
        </div>
        <div class="company">
            <div class="knocking" ref="knocking">
                <el-row>
                    <el-col :span="6" :offset="2" class="left" v-if="knockingTextShow">
                        <transition name="knocking" appear>
                            <div>
                                <div style="font-size: 50px;">
                                    爆震技术
                                </div>
                                <el-button type="primary" icon="el-icon-right" class="enterButton"
                                    style="margin-left: 7vw;" @click="$router.push('/knocking')">详细信息</el-button>
                            </div>
                        </transition>
                    </el-col>
                </el-row>
            </div>
            <div class="engine" ref="engine">
                <el-row>
                    <el-col :span="6" :offset="17" class="right" v-if="engineTextShow">
                        <transition name="engine" appear>
                            <div>
                                <div style="font-size: 60px;">
                                    航空动力
                                </div>
                                <!-- <div style="font-size: 50px;margin-top: 20px;">
                                    <div style="margin-left: 50px;">
                                        高性能
                                    </div>
                                    <div style="margin-left: 80px">
                                        高可靠
                                    </div>
                                    <div style="margin-left: 110px">
                                        航空动力
                                    </div>
                                </div> -->
                                <el-button type="primary" icon="el-icon-right" class="enterButton"
                                    style="margin-left: 8vw;" @click="$router.push('/engine?id=title')">详细信息</el-button>
                            </div>
                        </transition>
                    </el-col>
                </el-row>
            </div>
            <div class="energy" ref="energy">
                <el-row>
                    <el-col :span="6" :offset="2" class="left" v-if="energyTextShow">
                        <transition name="energy" appear>
                            <div>
                                <div style="font-size: 50px;">
                                    绿色能源
                                </div>
                                <el-button type="primary" icon="el-icon-right" class="enterButton"
                                    style="margin-left: 7vw;"@click="$router.push('/energy?id=title')">详细信息</el-button>
                            </div>
                        </transition>
                    </el-col>
                </el-row>
            </div>
            
            <div class="about" ref="about">
                <el-col :span="6" :offset="17" class="right" v-if="aboutTextShow">
                    <transition name="engine" appear>
                        <div>
                            <div style="font-size: 60px;">
                                关于我们
                            </div>
                            <el-button type="primary" icon="el-icon-right" class="enterButton" style="margin-left: 8vw;"
                                @click="$router.push('/about?id=title')">详细信息</el-button>
                        </div>
                    </transition>
                </el-col>

            </div>

            <!-- <div class="about">
                <div class="right" ref="about">
                    <div>
                        <transition name="about" appear v-if="aboutTextShow">
                            <div>
                                <div style="font-size: 50px;">
                                    关于我们
                                </div>
                                <el-button type="primary" icon="el-icon-right" class="enterButton"
                                    @click="$router.push('/about?id=title')">详细信息</el-button>
                            </div>
                        </transition>
                    </div>
                </div>
                <div class="left">
                    <img :src="require('@/assets/index/页面1-5.jpg')" class="video">
                </div>
            </div> -->
            <div class="joinUs">
                <!-- <img :src="require('@/assets/index/页面1-6.jpg')" class="pic"> -->
                <div class="left">

                </div>
                <div class="right" ref="joinUs">
                    <div style="margin-left: 44%;">
                        <transition name="joinUs" appear v-if="joinTextShow">
                            <div>
                                <div style="font-size: 50px;">
                                    加入我们
                                </div>

                                <el-button type="primary" icon="el-icon-right" class="enterButton"
                                    @click="$router.push('/about?id=title')">详细信息</el-button>
                            </div>
                        </transition>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>


<script>
import videoBackground from '../common/videoBackground.vue';
export default {
    components: { videoBackground },
    data() {
        return {
            knockingTextShow: false,
            engineTextShow: false,
            energyTextShow: false,
            aboutTextShow: false,
            joinTextShow: false,
            videoSrc: require('@/assets/index/最新版.mp4'),
            isLoop:false
        }
    },
    mounted() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        setTimeout(() => {
            window.addEventListener('scroll', this.handleScroll);
        }, 1000);
    },

    methods: {
        handleScroll() {
            if (this.knockingTextShow === false) {
                if (this.$refs.knocking) {
                    this.knockingTextShow = document.documentElement.scrollTop > this.$refs.knocking.getBoundingClientRect().top;
                }
            }
            if (this.engineTextShow === false) {
                if (this.$refs.engine) {
                    this.engineTextShow = document.documentElement.scrollTop > this.$refs.engine.getBoundingClientRect().top;
                }
            }
            if (this.energyTextShow === false) {
                if (this.$refs.energy) {
                    this.energyTextShow = document.documentElement.scrollTop > this.$refs.energy.getBoundingClientRect().top;
                }
            }
            if (this.aboutTextShow === false) {
                if (this.$refs.about) {
                    this.aboutTextShow = document.documentElement.scrollTop > this.$refs.about.getBoundingClientRect().top;
                }
            }
            if (this.joinTextShow === false) {
                if (this.$refs.joinUs) {
                    this.joinTextShow = document.documentElement.scrollTop > this.$refs.joinUs.getBoundingClientRect().top;
                }
            }
        },
        goToenEnergy() {
            window.open('http://www.Thu-e.com', '_blank', 'location=no');
        },
        // loopVideos() {
        //     this.videoSrc = require('@/assets/index/顶部视频2.mp4')
        //     this.isLoop = true
        //     this.$refs.videoElement.load();
        // }
    },

}
</script>
<style lang="scss" scoped>
.background-video {
    position: absolute;
    top: 50%;
    left: 49.9%;
    width: 101%;
    height: 100%;
    object-fit: cover;
    /* 确保视频覆盖整个背景 */
    transform: translate(-50%, -50%);
    z-index: -1;
    /* 视频置于底层 */
}

.logo {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: space-around;
    flex-wrap: wrap;
}

.logo-enter-active {
    transition: all 3s;
}

.logo-enter {
    opacity: 0;
    transform: translateY(-5%);
}


.knocking-enter-active {
    transition: all 4s;
}

.knocking-enter {
    opacity: 0;
    transform: translateX(50%);
}


.engine-enter-active {
    transition: all 4s;
}

.engine-enter {
    opacity: 0;
    transform: translateX(-50%);
}

.energy-enter-active {
    transition: all 4s;
}

.energy-enter {
    opacity: 0;
    transform: translateX(50%);
}

.about-enter-active {
    transition: all 4s;
}

.about-enter {
    opacity: 0;
    transform: translateX(-50%);
}

.joinUs-enter-active {
    transition: all 4s;
}

.joinUs-enter {
    opacity: 0;
    transform: translateX(-50%);
}

.company {
    .enterButton {
        margin-top: 3vh;
        background-color: #000;
        border: none;
    }

    .enterButton:hover {
        background-color: #2c2727;
    }

    .knocking {
        background-color: #2c2727;
        height: 100vh;
        background-image: url('../../assets/index/页面1-2.jpg');
        background-size: cover;
        background-repeat: no-repeat;

        .left {
            color: white;
            height: 100%;
            margin-top: 18%;
            font-family: QHKT;
            display: flex;
            flex-direction: column;
        }
    }

    .engine {
        background-color: #2c2727;
        height: 100vh;
        background-image: url('../../assets/index/页面1-3.jpg');
        background-repeat: no-repeat;
        background-size: cover;


        .right {
            color: white;
            height: 80%;
            margin-top: 15%;
            font-family: QHKT;
            display: flex;
            flex-direction: column;
        }
    }

    .energy {
        background-color: #2c2727;
        height: 100vh;
        background-image: url('../../assets/index/能源首页图.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;

        .left {
            color: white;
            height: 100%;
            margin-top: 18%;
            font-family: QHKT;
            display: flex;
            flex-direction: column;
        }
    }

    .about {
        background-color: #2c2727;
        height: 100vh;
        background-image: url('../../assets/index/关于我们.jpg');
        background-repeat: no-repeat;
        background-size: 100% 100%;

        .right {
            color: white;
            margin-top: 20%;
            font-family: QHKT;
            display: flex;
            flex-direction: column;
        }

    }
}

// .about {
//     width: 100%;
//     height: 100vh;
//     background-color: #000;
//     display: flex;
//     flex-direction: row;
//     justify-content: space-evenly;
//     font-family: QHKT;

//     .left {
//         width: 30vw;
//         height: 60vh;

//         .video {
//             margin-top: 20vh;

//             transform: translateX(-70%);
//             width: 100%;
//             height: 100%;
//             object-fit: cover;
//             /* 确保视频覆盖整个背景 */
//             z-index: 1;
//             /* 视频置于底层 */
//         }
//     }

//     .right {
//         width: 40vw;
//         height: 20vh;
//         margin-top: 20%;
//         display: flex;
//         flex-direction: column;
//         justify-content: center;
//         color: white;

//         .enterButton {
//             margin-top: 3vh;
//             margin-left: 7vw;
//             background-color: #000;
//             border: none;
//         }

//         .enterButton:hover {
//             background-color: #2c2727;
//         }
//     }
// }

.joinUs {
    width: 100%;
    height: 100vh;
    background: linear-gradient(rgba(56, 53, 53, 0.5), rgba(49, 46, 46, 0.5)), url('../../assets/index/页面1-6.jpg') center/cover no-repeat;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    font-family: QHKT;

    .pic {
        position: relative;
        height: 90%;
        width: 80%;
        margin: 5% 10%;
        opacity: 0.5;
        z-index: 1;
    }

    .left {
        width: 30vw;
        height: 20vh;
    }

    .right {
        width: 30vw;
        height: 20vh;
        margin-top: 20%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        color: white;

        .enterButton {
            margin-top: 5vh;
            margin-left: 7vw;
            background-color: #000;
            border: none;
        }

        .enterButton:hover {
            background-color: #2c2727;
        }

    }
}

.foot-menu {
    margin: 0 auto;
    position: relative;
    background-color: #333333;
    padding: 30px 50px;
    padding-bottom: 100px;
    font-size: 22px;
    // background-image: url('../../assets/图4.jpg');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    height: 70vh;

    .content {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        height: 100%;
    }

    .icon {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .title {
        display: flex;
        flex-direction: row;
        margin-left: 20px;
    }

    h3 {
        padding: 15px 0;
        font-weight: normal;
        font-size: 22px;
        text-align: left;
    }

    p {
        margin: 10px 0;

        // &:hover {
        //     color: rgb(172, 0, 0);
        //     cursor: pointer;
        // }
    }

    .right {
        display: flex;
        justify-content: center;
        padding: 0 50px;

        .right-content {
            width: 200px;
            height: 200px;

            img {
                width: 100%;
                height: 100%;
            }

            p {
                text-align: center;
            }
        }
    }

    .el-divider {
        background-color: rgba(187, 187, 187, 0.5);
        height: 50%;
    }

}
</style>
